import React from 'react';
import './CheckerBoard.css'
import Material from '../Material';
import Nums from './Nums'

class CardsandCounters extends React.Component {
  
  render(){
    return (
      <div>
        <Material />
        <div className="work-mat">
        <Nums />
        </div>
      </div>
    )
  }
}
export default CardsandCounters;